import { Injectable } from '@angular/core';
import {
  collection,
  collectionData,
  doc,
  docData,
  Firestore,
  query,
  updateDoc,
  where,
} from '@angular/fire/firestore';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { auditTime } from 'rxjs/operators';
import { EditChannel } from './channels.service';

export enum InviteStatus {
  INVITE_SENT = 'INVITE_SENT',
  INVITE_ACCEPTED = 'INVITE_ACCEPTED',
}
@Injectable({
  providedIn: 'root',
})
export class ClubRegistrationsService {
  constructor(private readonly fireStore: Firestore, private readonly functions: Functions) {}
  getClubsRegistrationData() {
    const collectionRef = collection(this.fireStore, 'clubRegistrations');
    const q = query(
      collectionRef,
      where('status', '==', InviteStatus.INVITE_SENT)
    );
    return collectionData(q, { idField: 'id' }).pipe(auditTime(700));
  }
  getClubRegistrationById(clubRegistrationId: string) {
    const docRef = doc(this.fireStore, 'clubRegistrations', clubRegistrationId);
    return docData(docRef);
  }
  updateClubRegistrationById(clubRegistrationId: string, obj: Partial<EditChannel>) {
    const docRef = doc(this.fireStore, 'clubRegistrations', clubRegistrationId);
    return updateDoc(docRef, obj);
  }
  deleteInvite(docId: string) {
    const docRef = doc(this.fireStore, 'clubRegistrations', docId);
    return updateDoc(docRef, { archived: true });
  }
  async resendActivationEmail(docId: string) {
    const callable = httpsCallable(
      this.functions,
      'club-sendPreRegisterInvite'
    );
    return (
      await callable({
        clubRegistrationId: docId,
      })
    ).data;
  }
}
